import { render, staticRenderFns } from "./RoleCardsView.vue?vue&type=template&id=5565b166&scoped=true"
import script from "./RoleCardsView.vue?vue&type=script&lang=js"
export * from "./RoleCardsView.vue?vue&type=script&lang=js"
import style0 from "./RoleCardsView.vue?vue&type=style&index=0&id=5565b166&prod&scoped=true&lang=scss"
import style1 from "./RoleCardsView.vue?vue&type=style&index=1&id=5565b166&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5565b166",
  null
  
)

export default component.exports